import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ReceiptLongIcon(props: IconProps) {
    return <Icon {...props} iconKey={"receipt_long"}/>
}
